// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebar {
    background-color: #092e2f;
    width: 280px;
    position: fixed;
    top: 0;
    left: 0;
    padding: 20px;
    height: 100%;
    z-index: 1026;
}

.spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;

}

.sidebar_logo i {
    font-size: 20px;
    color: #455a64;
    position: absolute;
    right: 24px;
    cursor: pointer;
    display: none;
    font-weight: 300;
}

.link_404 {
    color: #fff !important;
    padding: 10px 20px;
    background: #39ac31;
    margin: 20px 0;
    display: inline-block;
}

.contant_box_404 {
    margin-top: -50px;
}

.active_sidebar .sidebar_logo i {
    display: inline-flex;
    top: 29px;
    width: 38px;
    height: 38px;
    align-items: center;
    justify-content: center;
    background: #eceff1;
    border-radius: 6px;
}

header {
    justify-content: end;
}

.sidebar_menu li img {
    width: 15px;
    margin-right: 19px;
    filter: brightness(0) invert(1);
}

.sidebar_logo {
    padding: 0 10px 28px;
    width: 105px;
}

.sidebar_menu li a {
    font-weight: 400;
    color: #fff;
    font-size: 15px;
    display: block;
    padding: 10px 13px 10px 24px;
    margin-bottom: 8px;
    transition: .3s ease;
}

.sidebar_menu li a.active,
.sidebar_menu li a:hover {
    background-color: #fff;
    border-radius: 10px;
    transition: .3s ease;
    font-weight: 500;
    color: #0a2e2e;
}

.sidebar_menu li a.active img,
.sidebar_menu li a:hover img {
    filter: brightness(0) saturate(100%) invert(13%) sepia(13%) saturate(2684%) hue-rotate(132deg) brightness(89%) contrast(93%);
}

header {
    padding: 10px 0 10px;
}

header .dropdown-toggle::after {
    content: unset;
}

header .dropdown i.user-icon {
    font-size: 19px;
    color: #455A64;
    border: 1px solid #455A64;
    width: 30px;
    height: 30px;
}

/* 
header .dropdown span {
    width: 7px;
    height: 7px;
    border-radius: 100px;
    display: inline-block;
    position: absolute;
    right: 7px;
    top: 1px;
    background: #fa4343;
} */

header .dropdown-menu {
    box-shadow: 0 8px 26px -4px rgba(20, 20, 20, 0.15), 0 8px 9px -5px rgba(20, 20, 20, 0.06);
    background-color: #fff;
    border-radius: 10px;
    border: 0;
}


header .dropdown-item {
    font-size: 14px;
}

.btn.sidebar_btn {
    background-color: #2962FF;
    border-radius: 11px;
    padding: 12px;
    width: 42px;
    height: 42px;
    transform: rotate(90deg);
}

.btn.sidebar_btn:focus,
.btn.sidebar_btn:hover,
.btn.sidebar_btn:active {
    background-color: #2962FF;
}

.btn.sidebar_btn img {
    filter: brightness(0) invert(1);
}

.active_sidebar #sidebar {
    width: 280px;
    padding: 20px;
    display: block;
    transition: .3s ease;
    transform: translateX(0);
}

.active_sidebar .sidebar_overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #0000003d;
    z-index: 1024;
    display: block;
}


@media (max-width:1199px) {
    #sidebar {
        transform: translateX(-300px);
        transition: .3s ease;
    }

    header {
        justify-content: space-between;
    }
}

.searchBox .form-control,
.searchBox .form-select {
    padding: .5rem .75rem;
}

/* card header css */
.card-header-wrapper h3 {
    font-size: 18px;
    font-weight: 500;
    text-transform: uppercase;
    text-align: left;
}

.add_btn {
    background: #092e2f !important;
    border-color: #092e2f !important;
    font-size: 14px !important;
}

.table-responsive th {
    padding: 15px 13px !important;
    color: #0a2e2e !important;
    font-weight: 500;
    text-align: center;
}

.table-responsive td {
    padding: 12px 13px !important;
    /* text-transform: capitalize; */
    color: #666666 !important;
    font-size: 14px;
    text-align: center;
}

.table-responsive .table>:not(caption)>*>* {
    background: transparent;
}

.user_detail_card.table-responsive td,
.user_detail_card.table-responsive th {
    text-align: left;
}

.table-striped>tbody>tr:nth-of-type(odd)>* {
    background-color: rgba(94, 177, 191, 0.1);
}

.searchBox .form-control,
.searchBox .form-select {
    line-height: 19px;
}

.pagination .active>.page-link,
.page-link.active {
    background: #0a2e2e;
    border-color: #0a2e2e;
}

.date_birth_select .react-datepicker-wrapper {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/common/common.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,SAAS;;AAEb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,cAAc;IACd,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;IAEI,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,4HAA4H;AAChI;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;;;;;;;;;;GAUG;;AAEH;IACI,yFAAyF;IACzF,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,2BAA2B;IAC3B,aAAa;IACb,cAAc;AAClB;;;AAGA;IACI;QACI,6BAA6B;QAC7B,oBAAoB;IACxB;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf","sourcesContent":["#sidebar {\n    background-color: #092e2f;\n    width: 280px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    padding: 20px;\n    height: 100%;\n    z-index: 1026;\n}\n\n.spinner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n\n}\n\n.sidebar_logo i {\n    font-size: 20px;\n    color: #455a64;\n    position: absolute;\n    right: 24px;\n    cursor: pointer;\n    display: none;\n    font-weight: 300;\n}\n\n.link_404 {\n    color: #fff !important;\n    padding: 10px 20px;\n    background: #39ac31;\n    margin: 20px 0;\n    display: inline-block;\n}\n\n.contant_box_404 {\n    margin-top: -50px;\n}\n\n.active_sidebar .sidebar_logo i {\n    display: inline-flex;\n    top: 29px;\n    width: 38px;\n    height: 38px;\n    align-items: center;\n    justify-content: center;\n    background: #eceff1;\n    border-radius: 6px;\n}\n\nheader {\n    justify-content: end;\n}\n\n.sidebar_menu li img {\n    width: 15px;\n    margin-right: 19px;\n    filter: brightness(0) invert(1);\n}\n\n.sidebar_logo {\n    padding: 0 10px 28px;\n    width: 105px;\n}\n\n.sidebar_menu li a {\n    font-weight: 400;\n    color: #fff;\n    font-size: 15px;\n    display: block;\n    padding: 10px 13px 10px 24px;\n    margin-bottom: 8px;\n    transition: .3s ease;\n}\n\n.sidebar_menu li a.active,\n.sidebar_menu li a:hover {\n    background-color: #fff;\n    border-radius: 10px;\n    transition: .3s ease;\n    font-weight: 500;\n    color: #0a2e2e;\n}\n\n.sidebar_menu li a.active img,\n.sidebar_menu li a:hover img {\n    filter: brightness(0) saturate(100%) invert(13%) sepia(13%) saturate(2684%) hue-rotate(132deg) brightness(89%) contrast(93%);\n}\n\nheader {\n    padding: 10px 0 10px;\n}\n\nheader .dropdown-toggle::after {\n    content: unset;\n}\n\nheader .dropdown i.user-icon {\n    font-size: 19px;\n    color: #455A64;\n    border: 1px solid #455A64;\n    width: 30px;\n    height: 30px;\n}\n\n/* \nheader .dropdown span {\n    width: 7px;\n    height: 7px;\n    border-radius: 100px;\n    display: inline-block;\n    position: absolute;\n    right: 7px;\n    top: 1px;\n    background: #fa4343;\n} */\n\nheader .dropdown-menu {\n    box-shadow: 0 8px 26px -4px rgba(20, 20, 20, 0.15), 0 8px 9px -5px rgba(20, 20, 20, 0.06);\n    background-color: #fff;\n    border-radius: 10px;\n    border: 0;\n}\n\n\nheader .dropdown-item {\n    font-size: 14px;\n}\n\n.btn.sidebar_btn {\n    background-color: #2962FF;\n    border-radius: 11px;\n    padding: 12px;\n    width: 42px;\n    height: 42px;\n    transform: rotate(90deg);\n}\n\n.btn.sidebar_btn:focus,\n.btn.sidebar_btn:hover,\n.btn.sidebar_btn:active {\n    background-color: #2962FF;\n}\n\n.btn.sidebar_btn img {\n    filter: brightness(0) invert(1);\n}\n\n.active_sidebar #sidebar {\n    width: 280px;\n    padding: 20px;\n    display: block;\n    transition: .3s ease;\n    transform: translateX(0);\n}\n\n.active_sidebar .sidebar_overlay {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-color: #0000003d;\n    z-index: 1024;\n    display: block;\n}\n\n\n@media (max-width:1199px) {\n    #sidebar {\n        transform: translateX(-300px);\n        transition: .3s ease;\n    }\n\n    header {\n        justify-content: space-between;\n    }\n}\n\n.searchBox .form-control,\n.searchBox .form-select {\n    padding: .5rem .75rem;\n}\n\n/* card header css */\n.card-header-wrapper h3 {\n    font-size: 18px;\n    font-weight: 500;\n    text-transform: uppercase;\n    text-align: left;\n}\n\n.add_btn {\n    background: #092e2f !important;\n    border-color: #092e2f !important;\n    font-size: 14px !important;\n}\n\n.table-responsive th {\n    padding: 15px 13px !important;\n    color: #0a2e2e !important;\n    font-weight: 500;\n    text-align: center;\n}\n\n.table-responsive td {\n    padding: 12px 13px !important;\n    /* text-transform: capitalize; */\n    color: #666666 !important;\n    font-size: 14px;\n    text-align: center;\n}\n\n.table-responsive .table>:not(caption)>*>* {\n    background: transparent;\n}\n\n.user_detail_card.table-responsive td,\n.user_detail_card.table-responsive th {\n    text-align: left;\n}\n\n.table-striped>tbody>tr:nth-of-type(odd)>* {\n    background-color: rgba(94, 177, 191, 0.1);\n}\n\n.searchBox .form-control,\n.searchBox .form-select {\n    line-height: 19px;\n}\n\n.pagination .active>.page-link,\n.page-link.active {\n    background: #0a2e2e;\n    border-color: #0a2e2e;\n}\n\n.date_birth_select .react-datepicker-wrapper {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
